import {Box, Stack, Typography} from '@mui/material';
import FrontdeskButton from '~/components/FrontdeskButton';
import {PricingListTagIcon} from '~/assets/svgs';
import DownloadReportIcon from '$assets/svgs/download-report-icon.svg?react';
import DownloadReportModal from './DownloadReportModal';

import {useNavigate} from 'react-router-dom';
import {RoutePath} from '~/constants/routes';
import {useState} from 'react';
import {
  DownLoadReportIconStyle,
  dashboardTitleStyles,
  headerStackStyles,
  dashboardHeaderButtonBoxStyles,
} from './styles';

const DashboardHeader: React.FC = () => {
  const navigate = useNavigate();
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const handlePricingListClick = () => {
    navigate(RoutePath.staff.finance.dashboard.pricingList);
  };

  const handleDownloadReport = () => {
    setIsDownloadModalOpen(true);
  };

  const handleCloseDownloadModal = () => {
    setIsDownloadModalOpen(false);
  };

  return (
    <>
      <Stack sx={headerStackStyles}>
        <Typography variant="h5" sx={dashboardTitleStyles}>
          Dashboard
        </Typography>
        <Box sx={dashboardHeaderButtonBoxStyles}>
          <FrontdeskButton
            variant="accent"
            title="Pricing list"
            onClick={handlePricingListClick}
            startIcon={<PricingListTagIcon />}
          />
          <FrontdeskButton
            variant="primary"
            title="Download report"
            onClick={handleDownloadReport}
            startIcon={<DownloadReportIcon style={DownLoadReportIconStyle} />}
          />
        </Box>
      </Stack>

      <DownloadReportModal
        open={isDownloadModalOpen}
        onClose={handleCloseDownloadModal}
      />
    </>
  );
};

export default DashboardHeader;
